import { PaymentOption } from '../../model'
import { PaymentType } from '@afterpay/types'

export interface PCLProperties {
  installmentsCount: number[]
  apr: number[]
  interestAmount: string[]
  installmentAmount: string[]
  downPayment: string[]
}

export interface PaymentOptionData {
  paymentTypes: PaymentType[]
  installmentsCount?: number[]
  apr?: number[]
  interestAmount?: string[]
  installmentAmount?: string[]
  downPayment?: string[]
}

/**
 * Processes payment options data to extract payment types and PCL-specific properties
 *
 * @param response - Array of payment options from the API
 * @returns Object containing unique payment types and PCL-specific properties (if PCL type exists)
 * @throws Error if input is not an array
 */
export const handlePaymentOptionData = (response: PaymentOption[]): PaymentOptionData => {
  if (!Array.isArray(response)) {
    throw new Error('Payment options must be an array')
  }

  const paymentTypes = response.map((plan) => plan.paymentType).sort((a, b) => (a === PaymentType.PCL ? -1 : b === PaymentType.PCL ? 1 : 0))
  const hasPCL = response.some((paymentOption: PaymentOption) => paymentOption.paymentType === PaymentType.PCL)

  if (!hasPCL) {
    return { paymentTypes }
  }

  const pclProperties = response.reduce(
    (paymentOption: PCLProperties, option) => {
      if (option.paymentType !== PaymentType.PCL) {
        return paymentOption
      }
      paymentOption.installmentsCount.push(option.installmentsCount)
      if (option.apr != null) {
        paymentOption.apr.push(option.apr)
      }
      if (option.interestAmount?.amount != null) {
        paymentOption.interestAmount.push(option.interestAmount.amount)
      }
      paymentOption.installmentAmount.push(option.installmentAmount.amount)
      paymentOption.downPayment.push(option.amountDueToday.amount)
      return paymentOption
    },
    {
      installmentsCount: [],
      apr: [],
      interestAmount: [],
      installmentAmount: [],
      downPayment: [],
    }
  )

  return { paymentTypes, ...pclProperties }
}
